import { ShieldCheck } from 'lucide-react';

export default function PaymentBadges({ className = '' }) {
    return (
        <div className={`flex flex-wrap items-center gap-3 ${className}`} data-testid="payment-badges">
            <div className="flex items-center gap-1.5 text-xs font-body text-gray-500">
                <ShieldCheck className="w-4 h-4 text-green-600" />
                <span className="font-medium">Secure Checkout</span>
            </div>

            {/* Paystack */}
            <div className="flex items-center gap-1 bg-blue-50 border border-blue-100 rounded px-2 py-1">
                <svg viewBox="0 0 24 24" className="w-4 h-4" fill="none">
                    <path d="M2 4h20v2H2V4zm0 5h20v2H2V9zm0 5h14v2H2v-2zm0 5h14v2H2v-2z" fill="#00C3F7"/>
                </svg>
                <span className="text-[10px] font-body font-bold text-blue-700">Paystack</span>
            </div>

            {/* Visa */}
            <div className="bg-white border border-gray-200 rounded px-2 py-1">
                <svg viewBox="0 0 48 16" className="h-3.5 w-auto">
                    <text x="0" y="13" fontFamily="Arial, sans-serif" fontWeight="bold" fontSize="14" fill="#1A1F71">VISA</text>
                </svg>
            </div>

            {/* Mastercard */}
            <div className="bg-white border border-gray-200 rounded px-2 py-1 flex items-center gap-0.5">
                <svg viewBox="0 0 32 20" className="h-4 w-auto">
                    <circle cx="11" cy="10" r="8" fill="#EB001B" opacity="0.9"/>
                    <circle cx="21" cy="10" r="8" fill="#F79E1B" opacity="0.9"/>
                    <path d="M16 4.5a7.96 7.96 0 013 5.5 7.96 7.96 0 01-3 5.5A7.96 7.96 0 0113 10a7.96 7.96 0 013-5.5z" fill="#FF5F00"/>
                </svg>
            </div>

            {/* Verve */}
            <div className="bg-white border border-gray-200 rounded px-2 py-1">
                <span className="text-[10px] font-body font-bold text-blue-900">Verve</span>
            </div>

            {/* Bank Transfer */}
            <div className="bg-white border border-gray-200 rounded px-2 py-1">
                <span className="text-[10px] font-body font-medium text-gray-600">Bank Transfer</span>
            </div>
        </div>
    );
}
